'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const themeTokens = ['linksNoneDefault', 'linksNoneHover', 'buttonsPrimaryDefault', 'buttonsPrimaryHover', 'bodytextDefaultNone'];

exports.themeTokens = themeTokens;
